import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DespachosComponent } from './despachos/despachos.component';
import { DespachosRoutingModule } from './despachos.routing.module';
import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import { EditarDespachoComponent } from './editar-despacho/editar-despacho.component';
import { CrearEditarDespachoComponent } from './crear-editar-despacho/crear-editar-despacho.component';
import { ListadoComponent } from './despachos/listado/listado.component';
import { AsignarDespachosComponent } from './despachos/asignar-despachos/asignar-despachos.component';

@NgModule({
  declarations: [
    DespachosComponent,
    ListadoComponent,
    EditarDespachoComponent,
    CrearEditarDespachoComponent,
    AsignarDespachosComponent,
  ],
  imports: [CommonModule, AuxiliaresModule, DespachosRoutingModule],
  exports: [DespachosComponent, ListadoComponent, AsignarDespachosComponent],
})
export class DespachosModule {}
